import { getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { FdReportResultsOption } from 'Components/Worksheets/SandReplacementWorksheet/types';
import qestIds from '../../../QestIds';
import { FdMeasurementApplication, NuclearDensityGaugeMode } from '../../types';
import { getMoistureContentPercentFormat } from './../../../MoistureContentWorksheet/Bs/Config';
import getLabelConfig from './labelConfig';

const megagramsPerCubicMetreConfig = { uom: 'Mg/m³', format: { nearest: 0.001 } };
const kilogramsPerCubicMetreConfig = { uom: 'kg/m³', format: { nearest: 1 } };

const config = (_: string) =>
  mergeConfig(
    {
      'data.Preparation.BulkDensityCorrectionSlope': { format: { nearest: 0.001 } },
      'data.Preparation.BulkDensityCorrectionIntercept': megagramsPerCubicMetreConfig,
      'data.Preparation.MoistureDensityCorrectionSlope': { format: { nearest: 0.001 } },
      'data.Preparation.MoistureDensityCorrectionIntercept': megagramsPerCubicMetreConfig,

      ...getConfigForMeasuredTest(
        qestIds.moistureContent.BS_1377_2.rev1990,
        'data.EmbeddedMoistureContent.MoistureContentTest'
      ),

      'data.Measurements.Depth': { uom: 'mm', format: { nearest: 1 } },
      'data.Measurements.Readings.WetDensity': kilogramsPerCubicMetreConfig,
      'data.Measurements.Readings.WetDensityMeasured': megagramsPerCubicMetreConfig,
      'data.Measurements.Readings.MoistureDensity': kilogramsPerCubicMetreConfig,
      'data.Measurements.Readings.MoistureDensityMeasured': megagramsPerCubicMetreConfig,
      'data.Measurements.Readings.MoistureContentMeasured': { format: { nearest: 0.1 } },
      'data.Measurements.Readings.DryDensity': megagramsPerCubicMetreConfig,

      'data.EmbeddedMoistureContent.LabDryDensity': megagramsPerCubicMetreConfig,

      'data.Measurements.AverageReadings.MeanWetDensity': megagramsPerCubicMetreConfig,
      'data.Measurements.AverageReadings.MeanMoistureDensity': megagramsPerCubicMetreConfig,
      'data.Measurements.AverageReadings.MeanMoistureContent': { format: { nearest: 0.1 } },
      'data.Measurements.AverageReadings.MeanDryDensity': megagramsPerCubicMetreConfig,
      'data.IsParticleDensityAssumed': {
        options: [
          { label: 'Assumed', value: true },
          { label: 'Imported', value: false },
        ],
      },
      'data.ParticleDensityAssumed': { uom: 'Mg/m³', format: { nearest: 0.01 } },
      'data.ReferenceDensityResults.ParticleDensity': { uom: 'Mg/m³', format: { nearest: 0.01 } },
      'data.ReferenceDensityResults.MaximumDryDensity': { uom: 'Mg/m³', format: { nearest: 0.01 } },
      'data.ReferenceDensityResults.OptimumMoistureContent': { format: { nearest: 0.1 } },

      'data.Results.InsituMoistureContent': { format: getMoistureContentPercentFormat },
      'data.Results.InsituDryDensity': megagramsPerCubicMetreConfig,
      'data.Results.MaximumDryDensity': megagramsPerCubicMetreConfig,
      'data.Results.OptimumMoistureContent': { format: { nearest: 0.1 } },
      'data.Results.RelativeCompaction': { format: { nearest: 0.1 } },
      'data.Results.InsituAirVoids': { format: { nearest: 0.1 } },
      'data.Preparation.MeasurementApplication': {
        options: [
          { label: 'Ground investigation absolute tests', value: FdMeasurementApplication.AbsoluteTests },
          { label: 'Ground investigation comparative tests', value: FdMeasurementApplication.ComparativeTests },
          { label: 'Compliance test for compacted material', value: FdMeasurementApplication.ComplianceTest },
        ],
      },
      'data.Measurements.NuclearDensityGaugeMode': {
        options: [
          { label: 'Backscatter', value: NuclearDensityGaugeMode.Backscatter },
          { label: 'Direct Transmission', value: NuclearDensityGaugeMode.DirectTransmission },
        ],
      },
      'data.Results.ReportResultsOption': {
        options: [
          { label: 'Relative Compaction & Air Voids', value: FdReportResultsOption.RelativeCompactionAndAirVoids },
          { label: 'Relative Compaction Only', value: FdReportResultsOption.RelativeCompactionOnly },
          { label: 'Air Voids Only', value: FdReportResultsOption.AirVoidsOnly },
        ],
      },

      'data.Retest.OriginalTest.ImportedTest.Results.AirVoids': { format: { nearest: 0.1 } },
      'data.Retest.OriginalTest.ImportedTest.Results.RelativeCompaction': { format: { nearest: 0.1 } },
    },
    getLabelConfig('data')
  );

export default {
  [qestIds.nuclearFieldDensity.BS_1377_9_Clause_2_5.rev1990]: config,
};
